import React from 'react';

const escapeRegExp = (str: string): string =>
  str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

interface HighlightTextProps {
  text: string;
  searchKey: string;
  color?: string;
  highlightClassName?: string;
}

/**
 * React 组件版本 — 用于 JSX 直接渲染
 */
const HighlightText: React.FC<HighlightTextProps> = ({
  text,
  searchKey,
  color,
  highlightClassName,
}) => {
  // console.log(text, searchKey, color);
  // 当搜索关键词为空时直接返回原文本
  if (!searchKey.trim()) {
    return <span>{text}</span>;
  }

  // 转义正则特殊字符
  const escapedKey = searchKey.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escapedKey})`, 'gi');
  const parts = text.split(regex);

  return (
    <span>
      {parts.filter(part => part).map((part, index) => {
        const isMatch = regex.test(part);
        regex.lastIndex = 0; // 重置正则状态
        
        return isMatch ? (
          <span
            key={`highlight-${index}-${part}`}
            className={highlightClassName}
            style={{ color: color || 'lightblue' }}
          >
            {part}
          </span>
        ) : (
          <span key={`text-${index}-${part}`}>{part}</span>
        );
      })}
    </span>
  );
};

/**
 * HTML string 版本 — 用于 dangerouslySetInnerHTML 场景（如 InsightsReportCard）
 */
export const highlightToHtml = (
  text: string,
  searchKey: string,
  color = '#006EFF',
): string => {
  if (!searchKey?.trim() || !text) return text || '';
  const escapedKey = escapeRegExp(searchKey.trim());
  return text.replace(
    new RegExp(escapedKey, 'gi'),
    match => `<span style="color: ${color}">${match}</span>`,
  );
};

export default React.memo(HighlightText);